import "./changepassword.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import React, { useState } from "react";
import { changePassword } from "../../network/api/user.js";
import { Link } from "react-router-dom";
function ChangePassword({ setTabChosen }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showComfirmPassword, setShowComfrimPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const specialCharacters = /[!@#$%^&*(),.?":{}|<>]/;
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError("Passwords don't match.");
      return;
    }

    if (!newPassword.match(/[A-Z]/)) {
      setError("Password must contain at least one uppercase letter.");
      return;
    }

    if (!newPassword.match(/[a-z]/)) {
      setError("Password must contain at least one lowercase letter.");
      return;
    }

    if (!newPassword.match(/[0-9]/)) {
      setError("Password must contain at least one number.");
      return;
    }

    if (!specialCharacters.test(newPassword)) {
      setError(
        'Password must contain at least one special character: !@#$%^&*(),.?":{}|<>'
      );
      return;
    }

    setError("");
    changePassword({ password: newPassword, cPassword: confirmNewPassword })
      .then((response) => {
        let timeoutId = setTimeout(() => {
          setError(response.data.message);

          // Set a new timeout to clear setError after 1 second
          setTimeout(() => {
            setError("");
            clearTimeout(timeoutId);
          }, 3000);
          setNewPassword("");
          setConfirmNewPassword("");
        }, 1000);
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  return (
    <div className="changepassword d-flex justify-content-center align-items-center ">
      <div className="change-password">
        <div className="d-flex justify-content-between align-items-center ">
          <h1 className=" text-center flex-grow-1 ">تغير كلمة المرور</h1>
            {/* this will be displayed in large screen and meduim */}

          <div
            className="fs-2 d-none d-sm-none d-lg-block"
            style={{ lineHeight: "10px", cursor: "pointer" }}
            onClick={() => setTabChosen("user")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M17 2L2 17"
                stroke="#292D32"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 2L17 17"
                stroke="#292D32"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          {/* this will be displayed in samll screen only */}
          <div
            className="fs-2 fs-2 d-block d-lg-none"
            style={{ lineHeight: "10px", cursor: "pointer" }}
          >
            <a href="/profile">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M17 2L2 17"
                stroke="#292D32"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 2L17 17"
                stroke="#292D32"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            </a>
          </div>
        </div>
        {error && error !== "Success" && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {error === "Success" && (
          <div className="alert alert-success" role="alert">
            Password changed successfully!
          </div>
        )}
        <form onSubmit={handleSubmit} className="">
          <div className="form-group">
            <label htmlFor="newPassword">تحديث كلمه السر</label>
            <div className="input-group item h-25">
              <input
                // style={{padding:"14px" }}
                type={showPassword ? "text" : "password"}
                className="rounded-1 flex-grow-1"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                style={{ outline: "#confpay" }}
              />
              <div className="input-group-append pe-1">
                <button
                  className=""
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                </button>
              </div>
            </div>
          </div>

          <div className="form-group mt-4 ">
            <label htmlFor="confirmNewPassword">تأكد تحديث كلمه السر</label>
            <div className="input-group item h-25 ">
              <input
                type={showComfirmPassword ? "text" : "password"}
                className="rounded-1 flex-grow-1"
                id="confirmNewPassword"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
              />

              <div className="input-group-append pe-1">
                <button
                  className=""
                  type="button"
                  onClick={() => setShowComfrimPassword(!showComfirmPassword)}
                >
                  {showComfirmPassword ? (
                    <AiOutlineEye />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center ">
            <button className={`btn mt-5`}>تغيير كلمة المرور</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
